export type Faq = {
  question: string;
  answer: string;
};

export const faqs: Faq[] = [
  {
    question: "What data is required to start?",
    answer:
      "Onboarding starts with site metadata (location, technology, capacity), asset hierarchy, and access to relevant monitoring or operational systems such as inverter portals, SCADA, or historical data exports. Deployment timing depends on portfolio size, equipment mix, and data availability.",
  },
  {
    question: "How is expected production modeled?",
    answer:
      "Expected production is modeled from site configuration, historical operating data, and a long-term location-based PV yield benchmark. Actual production is compared against this expected-versus-actual yield index rather than a single universal accuracy figure, since local conditions and equipment vary. See the Validation Methodology page for details.",
  },
  {
    question: "How are losses verified before they are reported?",
    answer:
      "A detected deviation is treated as a candidate loss until it passes data-quality checks and is cross-checked against alternative explanations such as weather, curtailment, or planned downtime. Confirmed losses are linked to supporting evidence rather than reported from a single signal alone.",
  },
  {
    question: "What does storage analysis cover today?",
    answer:
      "For sites with battery storage, WoozyAI analyzes state-of-charge, cycling, and dispatch data to identify improvement opportunities and financially prioritized recommendations. WoozyAI does not claim autonomous dispatch or direct control of battery hardware.",
  },
  {
    question: "How do the carbon and ESG outputs work?",
    answer:
      "Carbon outputs are calculated from verified generation and avoided-emissions logic and are intended to support reporting preparation with framework-aligned outputs and an audit-ready evidence workflow. Carbon-credit eligibility, verification, issuance, and pricing depend on the project, jurisdiction, applicable methodology, registry, verification body, contractual attributes, and market conditions. WoozyAI supports calculation, documentation, workflow preparation, coordination, tracking, and monetization support where applicable, and does not guarantee compliance, filing, issuance, or that every site qualifies.",
  },
  {
    question: "How is security and data governance handled?",
    answer:
      "WoozyAI applies role-based access control, audit logging, and data lineage tracking across ingested telemetry and generated outputs, so operators, lenders, and sustainability teams can trace figures back to source data. Details on request via the Integrations and Validation Methodology pages.",
  },
];
